import React from 'react';
import { motion } from 'framer-motion';
export function Welcome() {
  return <section id="our-story" className="bg-cream texture-linen overflow-hidden" data-id="element-291">
      {/* Mobile layout */}
      <div className="md:hidden px-6 py-20" data-id="element-292">
        <div className="mb-8" data-id="element-293">
          <img src="https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=1200&q=80" alt="Elegant garden estate at Copper Crest" className="w-full aspect-[4/5] object-cover" data-id="element-294" />
        </div>
        <span className="block text-copper text-xs font-semibold tracking-[0.2em] uppercase mb-4" data-id="element-295">
          Welcome to Copper Crest
        </span>
        <h2 className="font-serif text-4xl text-charcoal leading-tight mb-8" data-id="element-296">
          A Legacy of Elegance
        </h2>
        <div className="space-y-6 text-muted font-light leading-relaxed text-base" data-id="element-297">
          <p data-id="element-298">
            Nestled amidst rolling hills and ancient oaks, Copper Crest stands
            as a testament to timeless architecture and natural beauty. For over
            a century, our estate has been the backdrop for life's most
            extraordinary celebrations.
          </p>
          <p data-id="element-299">
            Every corner of our grounds has been thoughtfully curated to offer
            an atmosphere of refined luxury. From the sunlit terraces to the
            grand ballroom, we provide a canvas where your unique story can
            unfold with grace and sophistication.
          </p>
        </div>
        <a href="#story" className="inline-block mt-10 text-charcoal uppercase tracking-widest text-sm font-medium pb-1 border-b border-copper hover:text-copper transition-colors" data-id="element-300">
          Discover Our Story
        </a>
      </div>

      {/* Desktop layout — image bleeds right, text overlaps */}
      <div className="hidden md:block relative py-32 lg:py-40" data-id="element-301">
        {/* Image — flush to right edge */}
        <motion.div initial={{
        opacity: 0,
        x: 60
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1.2
      }} className="absolute right-0 top-12 bottom-12 w-[58%] lg:w-[55%]" data-id="element-302">
          <img src="https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=1200&q=80" alt="Elegant garden estate at Copper Crest" className="w-full h-full object-cover" data-id="element-303" />
        </motion.div>

        {/* Text panel — overlaps image */}
        <motion.div initial={{
        opacity: 0,
        x: -40
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1,
        delay: 0.3
      }} className="relative z-10 ml-8 lg:ml-16 xl:ml-24 w-[55%] lg:w-[52%] xl:w-[48%] mt-16" data-id="element-304">
          <div className="bg-white p-12 lg:p-16 shadow-2xl" data-id="element-305">
            <span className="block text-copper text-xs font-semibold tracking-[0.2em] uppercase mb-4" data-id="element-306">
              Welcome to Copper Crest
            </span>

            <svg className="mb-6 opacity-40" width="60" height="12" viewBox="0 0 60 12" fill="none" data-id="element-307">
              <path d="M0 6 Q 15 6 30 6 T 60 6" stroke="#B87333" strokeWidth="1" data-id="element-308" />
              <path d="M25 6 Q 30 0 35 6 Q 30 12 25 6" stroke="#B87333" strokeWidth="1" fill="none" data-id="element-309" />
            </svg>

            <h2 className="font-serif text-4xl lg:text-5xl xl:text-6xl text-charcoal leading-tight mb-8" data-id="element-310">
              A Legacy of Elegance
            </h2>

            <div className="space-y-6 text-muted font-light leading-relaxed text-base lg:text-lg" data-id="element-311">
              <p data-id="element-312">
                Nestled amidst rolling hills and ancient oaks, Copper Crest
                stands as a testament to timeless architecture and natural
                beauty. For over a century, our estate has been the backdrop for
                life's most extraordinary celebrations.
              </p>
              <p data-id="element-313">
                Every corner of our grounds has been thoughtfully curated to
                offer an atmosphere of refined luxury. From the sunlit terraces
                to the grand ballroom, we provide a canvas where your unique
                story can unfold with grace and sophistication.
              </p>
            </div>

            <a href="#story" className="inline-block mt-10 text-charcoal uppercase tracking-widest text-sm font-medium pb-1 border-b border-copper hover:text-copper transition-colors" data-id="element-314">
              Discover Our Story
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}